import { Component, effect, inject, signal } from '@angular/core';
import {
  GcTextComponent,
  IpoLanguageService,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { combineLatest } from 'rxjs';
import { SharedModule } from '../../../../../shared.module';
import { SignatureDataService } from '../../../../../signature/service/signature-data/signature-data.service';
import { FileMetaData } from '../../../../self-inspection-v2/self-inspection-v2-entities';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-self-inspections',
  standalone: true,
  imports: [GcTextComponent, IpoTranslatePipe, SharedModule],
  templateUrl: './self-inspections.component.html',
  styleUrl: './self-inspections.component.scss',
})
export class SelfInspectionsComponent {
  languageService = inject(IpoLanguageService);
  signatureDataService = inject(SignatureDataService);

  selfInspectionData =
    this.signatureDataService.storedSelfInspectionSigningData;
  language = toSignal(this.languageService.getLanguage$(), {
    initialValue: this.languageService.getStoredLanguage() ?? 'en',
  });
  attachments = signal<Record<string, string[]>>({});

  constructor() {
    effect(() => {
      this.updateAttatchments();
    });
  }

  updateAttatchments() {
    const imageUrls: Record<string, string[]> = {};
    this.selfInspectionData().forEach((selfInspection) => {
      if (selfInspection.answer.attachments.length) {
        this.getImageUrls(selfInspection.answer.attachments).subscribe(
          (urls) => {
            imageUrls[selfInspection.definition.id] = urls;
            this.attachments.set({ ...imageUrls });
          },
        );
      }
    });
  }

  getImageUrls(attachments: FileMetaData[]) {
    const imageUrls = attachments.map((attachment) =>
      this.signatureDataService.getFileUrl$(
        attachment.fileId,
        attachment.fileName,
      ),
    );
    return combineLatest(imageUrls);
  }
}
